import type { CreateInvoiceCommandData } from '@festina/moneyin-general-types/moneyin'
import { InvoicesService } from '@festina/moneyin-general-types/moneyin/services/InvoicesService'
import { useFestinaMutation } from '@festina-life/authentication'
import { assertNotEmpty, type Optional } from '@festina-life/core'

const method =
  InvoicesService.installmentPlansServicePostApproveCancellationInstallmentPlan

export const useApproveCancelCreateInstallmentPlanInvoice = ({
  tenantId,
  commandId,
}: {
  tenantId: string
  commandId?: Optional<string>
}) =>
  useFestinaMutation({
    component: 'moneyIn',
    roles:
      InvoicesService.installmentPlansServicePostApproveCancellationInstallmentPlan_roles,
    isScenario: false,
    mutateFunction: async ({
      invoiceSpecification,
    }: CreateInvoiceCommandData) => {
      assertNotEmpty(commandId)
      assertNotEmpty(invoiceSpecification?.invoiceId)
      await method({
        xTenantId: tenantId,
        commandId,
        installmentPlanInvoiceId: invoiceSpecification.invoiceId,
      })
    },
  })
